module.exports = __webpack_public_path__ + "media/images/emblems/Seehof-coat_of_arms-69029d5d5373890b59b6957ab60f1c27.svg";